import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Styles from './AppliedJobs.module.scss'
import importedStyles from '../AvailableJobs/AvailableJobs.module.scss'
import axios from "axios";


//icons
import AppRegistrationOutlinedIcon from '@mui/icons-material/AppRegistrationOutlined';
import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';

import { JobCard } from "components/global/JobCard/JobCard";
export function AppliedJobs() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();


    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)
            try {
                const response = await axios.get(`/api/hiring/jobs/applied`);
                setData(response.data.data)
                setLoading(false)
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        !loading ?
            <div className={Styles.mainContainer}>

                <div className={importedStyles.jobContainer}>
                    {data?.map((job, index) => {
                        return (
                            <JobCard
                                key={index + 'job'}
                                data={job}
                                callback={() => { navigate(`/hiring/jobs/${job?.id}/applied`); }}
                            />
                        )
                    })}
                </div>
                <div className={`${importedStyles.filterContainer} ${Styles.sideContainer}`}>
                    <div className={Styles.statusCount}>
                        <AppRegistrationOutlinedIcon sx={{ color: '#3974c1' }} />
                        <span style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <p style={{ fontSize: '32px' }}>{data.length}</p>
                            <p style={{ fontWeight: 'normal' }}>Applied</p>
                        </span>
                    </div>
                    <div className={Styles.statusCount}>
                        <CheckCircleOutlinedIcon sx={{ color: 'green' }} />
                        <span style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <p style={{ fontSize: '32px' }}>
                                {
                                    data.filter((job) => job?.app_status === 'accepted').length
                                }
                            </p>
                            <p style={{ fontWeight: 'normal' }}>Accepted</p>
                        </span>
                    </div>
                    <div className={Styles.statusCount}>
                        <RemoveRedEyeOutlinedIcon sx={{ color: '#f28500' }} />
                        <span style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <p style={{ fontSize: '32px' }}>
                                {
                                    data.filter((job) => job?.app_status === 'inReview').length
                                }
                            </p>
                            <p style={{ fontWeight: 'normal' }}>In-review</p>
                        </span>
                    </div>
                    <div className={Styles.statusCount}>
                        <ChecklistOutlinedIcon sx={{ color: '#ffbf00' }} />
                        <span style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <p style={{ fontSize: '32px' }}>
                                {
                                    data.filter((job) => job?.app_status === 'shortlisted').length
                                }
                            </p>
                            <p style={{ fontWeight: 'normal' }}>Shortlisted</p>
                        </span>
                    </div>
                    <div className={Styles.statusCount}>
                        <CancelOutlinedIcon sx={{ color: 'red' }} />
                        <span style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <p style={{ fontSize: '32px' }}>
                                {
                                    data.filter((job) => job.app_status === 'rejected').length
                                }
                            </p>
                            <p style={{ fontWeight: 'normal' }}>Rejected</p>
                        </span>
                    </div>



                </div>

            </div>
            : <p>You have not applied for any jobs!</p>

    )
}
